import { applyTemplateResource, bulkTemplateResource } from './resource';
export const applyTemplate = (templateId, domainId) => {
  const body = {
    object_type: 'domain',
    object_id: domainId
  };
  return applyTemplateResource.post(`/templates/templates/${templateId}`, body, {
    label: `applyTemplate_${templateId}_${domainId}`,
    on202: response => response,
    not202: response => Promise.reject(response)
  });
};

// No doc for Bulk, see PostParam in api/template/bulks for more info

export const executeBulkCommand = (data, options = {}) =>
// $FlowFixMe[cannot-spread-indexer]
bulkTemplateResource.post('/templates/bulk', data, {
  // FIXME: in case of concurent bulkActions
  label: 'executeBulkCommand',
  on200: response => response,
  not200: response => Promise.reject(response),
  ...options
});
const computeBulkApplyTemplateData = (templateId, domainIds) => domainIds.map(domainId => ({
  body: {
    object_type: 'domain',
    object_id: domainId
  },
  client_ref: domainId,
  method: 'POST',
  uri: `/templates/${templateId}`
}));
export const bulkApplyTemplate = (templateId, domainIds) => {
  const data = computeBulkApplyTemplateData(templateId, domainIds);
  return executeBulkCommand(data);
};